<template>
  <TopBar
    v-if="props.showTopBar"
    :title="props.title"
    :hide-back-button="props.hideBackButton"
    :show-close-button="props.showCloseButton"
    :close-action="props.closeAction"
    :back-action="props.backAction"
    :center-title="props.centerTitle"
    :clickable-title="props.clickableTitle"
  />

  <div
    class="flex flex-col"
    :class="[
      props.useConditionalHeight
        ? props.hasData
          ? 'min-h-full'
          : 'h-screen'
        : 'min-h-full',
      {
        'pt-[53px]': props.showTopBar,
        'pb-[64px]': props.showBottomNav,
        [props.backgroundColor]: props.backgroundColor
      }
    ]"
  >
    <slot></slot>
  </div>

  <BottomNav v-if="props.showBottomNav" />
</template>

<script setup lang="ts">
const props = defineProps({
  showTopBar: {
    type: Boolean,
    default: false
  },
  showBottomNav: {
    type: Boolean,
    default: false
  },
  hideBackButton: {
    type: Boolean,
    default: false
  },
  showCloseButton: {
    type: Boolean,
    default: false
  },
  closeAction: {
    type: Function,
    default: null
  },
  backAction: {
    type: Function,
    default: null
  },
  title: {
    type: String,
    default: ''
  },
  backgroundColor: {
    type: String,
    default: ''
  },
  centerTitle: {
    type: Boolean,
    default: false
  },
  clickableTitle: {
    type: Boolean,
    default: false
  },
  useConditionalHeight: {
    type: Boolean,
    default: false
  },
  hasData: {
    type: Boolean,
    default: true
  }
})
</script>
